import React from "react";
import Swal from "sweetalert2";
import { fetchData } from "../helper/api.interceptor";
import { Icon } from "@iconify/react";

const DeleteSolarPanelButton = ({ id, onDeleted }) => {
    const handleDeleteClick = async () => {
        const confirm = await Swal.fire({
            title: "Are you sure?",
            text: "This solar panel will be deleted.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
        });

        if (confirm.isConfirmed) {
            try {
                const res = await fetchData.delete(`/solar/delete?id=${id}`);
                if (res.status_code === 200) {
                    onDeleted();
                    Swal.fire("Deleted!", "Solar panel has been deleted.", "success");
                } else {
                    Swal.fire("Error", "Failed to delete solar panel.", "error");
                }
            } catch (err) {
                Swal.fire("Error", "Something went wrong", "error");
            }
        }
    };

    return (
        <button
            className="w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center border-0"
            onClick={handleDeleteClick}
        >
            <Icon icon="mingcute:delete-2-line" />
        </button>
    );
};

export default DeleteSolarPanelButton;
